import React, { useState } from "react";
import moment from "moment";
import { Typography } from "antd";

const NetworkWiring = ({ rows, columns, selectedModelData }) => {
  const processorModel = selectedModelData.processorModel;
  const maxPixelCapacity = selectedModelData.maxPixelCapacity[0].pixel;
  const maxPixelCapacityUnit = selectedModelData.maxPixelCapacity[0].unit;

  const maxPowerConsumption = selectedModelData.maxPowerConsumption[0].width;
  const maxPowerConsumptionUnit = selectedModelData.maxPowerConsumption[0].unit;

  const panelResolutionWidth = selectedModelData.panelResolution[0].width;
  const panelResolutionHeight = selectedModelData.panelResolution[0].height;

  const panelWidth = selectedModelData.panelResolution[0].width;
  const panelHeight = selectedModelData.panelResolution[0].height;
  const pixelsPerPanel = panelWidth * panelHeight; // 36864
  const maxPanels = Math.floor(maxPixelCapacity / pixelsPerPanel); // 17

  const totalPanels = rows * columns;

  // Build the path in reversed snake order (start at upper right)
  const buildPath = () => {
    let path = [];
    let num = 1;
    for (let r = 0; r < rows; r++) {
      if (r % 2 === 0) {
        // right to left (first row)
        for (let c = columns - 1; c >= 0; c--) {
          if (num > totalPanels) break;
          path.push({ r, c, num });
          num++;
        }
      } else {
        // left to right
        for (let c = 0; c < columns; c++) {
          if (num > totalPanels) break;
          path.push({ r, c, num });
          num++;
        }
      }
    }
    return path;
  };

  // Render the grid based on the path
  const generateGrid = () => {
    const path = buildPath();
    // Create a 2D array for grid placement
    let grid = Array.from({ length: rows }, () => Array(columns).fill(null));
    path.forEach((panel) => {
      grid[panel.r][panel.c] = panel;
    });
    // Render the grid row by row, but each cell is styled based on the path
    let boxes = [];
    for (let r = 0; r < rows; r++) {
      for (let c = 0; c < columns; c++) {
        const panel = grid[r][c];
        if (!panel) continue;
        let classes = ["sample-view-box"];
        // Add start class for 1, 18, 35, ...
        // if ((panel.num - 1) % maxPanels === 0)
        //   classes.push("sample-view-start");
        // Add stop class for 17, 34, 51, ...
        // if (panel.num % maxPanels === 0) classes.push("sample-view-stop");
        // Find this panel's index in the path
        const idx = path.findIndex(
          (p) => p.r === panel.r && p.c === panel.c && p.num === panel.num
        );
        const nextPanel = path[idx + 1];
        // Only draw arrow if this is NOT the end of a chain
        if (
          nextPanel &&
          panel.num % maxPanels !== 0 // Do not draw arrow from 17->18, 34->35, etc.
        ) {
          // If next panel is in the same row, draw horizontal arrow
          if (nextPanel.r === panel.r) {
            if (nextPanel.c > panel.c) {
              classes.push("network-view-arrow-right");
            } else if (nextPanel.c < panel.c) {
              classes.push("network-view-arrow-left");
            }
          } else if (nextPanel.r > panel.r) {
            // If next panel is in the next row, draw down arrow
            classes.push("network-view-arrow-down");
          }
        }
        boxes.push(
          <div
            key={panel.r + "-" + panel.c}
            className={classes.join(" ")}
            style={{ gridRow: r + 1, gridColumn: c + 1 }}
          >
            <span
              style={{
                fontSize: "10px",
                backgroundColor: "green",
                width: 20,
                borderRadius: 10,
                padding: "2px",
                color: "white",
              }}
            >
              {panel.num}
            </span>
          </div>
        );
      }
    }
    return boxes;
  };

  return (
    <>
      <div className="sample-view-container">
        <div
          className="sample-view-grid"
          style={{ gridTemplateColumns: `repeat(${columns}, 50px)` }}
        >
          {generateGrid()}
        </div>
      </div>
      <div
        style={{
          marginTop: "10px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{
            color: "#000",
            fontSize: 14,
            textAlign: "center",
          }}
        >
          Power network Diagram(Front View)
        </Typography>
        <div
          style={{
            width: "100%",
            display: "flex",
            marginTop: "5px",
          }}
        >
          <div
            style={{
              border: "1px solid #000",
              width: "33%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Panel Layout(WxH):
              {columns}(W) {rows}(H), total {columns * rows} pc(s)
            </Typography>
          </div>
          <div
            style={{
              border: "1px solid #000",
              width: "34%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Resolution:
              {columns * panelResolutionWidth}
              (W) {rows * panelResolutionHeight}
              (H), total{" "}
              {parseInt(columns * panelResolutionWidth) *
                parseInt(rows * panelResolutionHeight)}{" "}
              Dots
            </Typography>
          </div>
          <div
            style={{
              border: "1px solid #000",
              width: "33%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Date: {moment().format("LL")}
            </Typography>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            marginTop: "5px",
          }}
        >
          <div
            style={{
              border: "1px solid #000",
              width: "33%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Max Power Consumption: {maxPowerConsumption}{" "}
              {maxPowerConsumptionUnit}
            </Typography>
          </div>
          <div
            style={{
              border: "1px solid #000",
              width: "34%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Processor Model:
              {processorModel}
            </Typography>
          </div>
          <div
            style={{
              border: "1px solid #000",
              width: "33%",
              display: "flex",
              alignItems: "center",
              paddingLeft: "8px",
            }}
          >
            <Typography style={{ fontSize: 12, color: "#000" }}>
              Max Pixel Capacity:
              {maxPixelCapacity} {maxPixelCapacityUnit}
            </Typography>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            marginTop: "5px",
            border: "1px solid #000",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography style={{ fontSize: 12, color: "#000" }}>
            Total Processor: {Math.ceil(totalPanels / maxPanels)}
          </Typography>
        </div>
      </div>
    </>
  );
};

export default NetworkWiring;
